import { ApiCall } from "../../../helper/axios";
import { setAdminAuth } from "../../../helper/adminAuthStorage";

// Exchange the one-time SSO code (from the WordPress admin redirect) for an
// admin token via the Node backend, and store it. Returns true on success.
export const exchangeSsoCode = async (code) => {
  try {
    const res = await ApiCall("POST", "/admin/sso/exchange", { code }, {});
    const body = res?.data;
    const data = body?.statusCode && body?.data ? body.data : body;
    const ok = body?.statusCode === 200 || res?.status === 200;
    if (ok && data?.token) {
      setAdminAuth(data.token, data.user, data.expires_in ?? data.expiresIn);
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};
